import { getIsEnableTimedEntryFF } from '.';
import { CheckoutState } from '../../state';
import { getChildEventId } from '../event/getChildEventId';
import { getIsAppRebrandActive } from './getIsAppRebrandActive';

export const getShouldShowCalendarSelection = (state: CheckoutState) =>
    getIsEnableTimedEntryFF(state) ||
    (getIsAppRebrandActive(state) && !!getChildEventId(state));
